export default {
  ROOT: 'user/',
  SET_USER: 'SET_USER',
  SET_OSAID: 'SET_OSAID',
  SET_SUPPORT_SELECTED: 'SET_SUPPORT_SELECTED',
};
